import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideRouter,
  RouteReuseStrategy,
  TitleStrategy,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import {
  heroArrowPath,
  heroArrowTopRightOnSquare,
  heroArrowDownTray,
  heroArrowUp,
  heroArrowUturnLeft,
  heroCheck,
  heroChevronRight,
  heroClipboardDocument,
  heroEye,
  heroLockClosed,
  heroMagnifyingGlass,
  heroPhoto,
  heroPencilSquare,
  heroPlus,
  heroTrash,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import {
  heroChevronDoubleLeftSolid,
  heroChevronDoubleRightSolid,
  heroChevronLeftSolid,
  heroNoSymbolSolid,
  heroChevronRightSolid,
} from '@ng-icons/heroicons/solid';

import { routes } from './app.routes';
import { provideIcons } from '@ng-icons/core';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { diagnosticsInterceptor } from './core/interceptors/diagnostics.interceptor';
import { AppTitleStrategy } from './core/routing/app-title.strategy';
import { CustomerRouteReuseStrategy } from './core/routing/customer-route-reuse.strategy';
import { AuthService } from './core/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    { provide: RouteReuseStrategy, useClass: CustomerRouteReuseStrategy },
    provideAppInitializer(() => inject(AuthService).restoreSession()),
    provideHttpClient(withInterceptors([diagnosticsInterceptor, authInterceptor])),
    provideIcons({
      heroXMark,
      heroArrowPath,
      heroArrowTopRightOnSquare,
      heroChevronRight,
      heroChevronDoubleLeftSolid,
      heroChevronDoubleRightSolid,
      heroChevronLeftSolid,
      heroNoSymbolSolid,
      heroChevronRightSolid,
      heroClipboardDocument,
      heroMagnifyingGlass,
      heroPhoto,
      heroPencilSquare,
      heroArrowDownTray,
      heroArrowUp,
      heroArrowUturnLeft,
      heroCheck,
      heroEye,
      heroLockClosed,
      heroPlus,
      heroTrash,
    }),
  ],
};
